import React from "react";

import { sliderConstants } from "../../constants";
import { ReactComponent as NextArrowIcon } from "../../assets/icons/slider/next-arrow.svg";
import { ReactComponent as PrevArrowIcon } from "../../assets/icons/slider/prev-arrow.svg";

const { CONTROL_TYPE_NEXT, CONTROL_TYPE_PREV } = sliderConstants;

const Slider = ({ length = 0, slideCurrentIndex, setSlideCurrentIndex }) => {
  const handleMoveSlider = (type) => {
    if (type === CONTROL_TYPE_NEXT) {
      setSlideCurrentIndex(
        slideCurrentIndex === length - 1 ? 0 : slideCurrentIndex + 1
      );
    } else {
      setSlideCurrentIndex(
        slideCurrentIndex === 0 ? length - 1 : slideCurrentIndex - 1
      );
    }
  };

  const getVisibleDots = () => {
    const maxDots = 10;

    // If total slides are less than or equal to maxDots, show all
    if (length <= maxDots) {
      return Array.from({ length }, (_, i) => i);
    }

    const half = Math.floor(maxDots / 2);

    // Near the start
    if (slideCurrentIndex < half) {
      return Array.from({ length: maxDots }, (_, i) => i);
    }

    // Near the end
    if (slideCurrentIndex > length - half - 1) {
      return Array.from({ length: maxDots }, (_, i) => length - maxDots + i);
    }

    // Centered around current index
    return Array.from(
      { length: maxDots },
      (_, i) => slideCurrentIndex - half + i
    );
  };

  return (
    <>
      {length > 0 && (
        <div className="mt-3 py-2 d-flex slider-container align-items-center">
          {getVisibleDots().map((index) => (
            <div
              key={index}
              className={`slide pointer ${
                slideCurrentIndex === index ? "selected-slide" : ""
              }`}
              onClick={() => setSlideCurrentIndex(index)}
            />
          ))}

          <PrevArrowIcon
            width={32}
            height={12}
            className="pointer"
            onClick={() => handleMoveSlider(CONTROL_TYPE_PREV)}
          />
          <NextArrowIcon
            width={32}
            height={12}
            className="pointer"
            onClick={() => handleMoveSlider(CONTROL_TYPE_NEXT)}
          />
        </div>
      )}
    </>
  );
};

export default Slider;
